import { createRoot } from "react-dom/client";
import { Web3Provider } from "./providers/Web3Provider";
import App from "./App.tsx";
import "./index.css";
import { ErrorBoundary } from "./providers/ErrorBoundary";

createRoot(document.getElementById("root")!).render(
  <ErrorBoundary>
    <Web3Provider>
      <App />
    </Web3Provider>
  </ErrorBoundary>
);
